import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const cityRuleDesc = async (params: object) => {
  return await GET({ url: Api.cityRuleDesc, params, showError: false })
}
